import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import logoImg from '../../images/logo.png';
import clsx from 'clsx';

type LogoProps = {
    className?: string,
    style?: React.CSSProperties,
};

Logo.defaultProps = {
    className: '',
    style: {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    logoContainer: {
        width: '100%',
        height: 120,
        padding: theme.spacing(2),
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
}));

function Logo(props: LogoProps): React.ReactElement {
    const {
        className,
        style = Logo.defaultProps.style,
    } = props;
    const classes = useStyle();

    return (
        <div className={clsx(classes.logoContainer, className)} style={style}>
            <img src={logoImg} alt="logo" />
        </div>
    );
}

export { Logo };
